import { toast } from 'react-toastify';
import { XCircle, CheckCircle, AlertTriangle, Info } from 'react-feather';

export function success(message) {
  toast.success(
    <div>
      <CheckCircle
        style={{ marginRight: '0.3rem' }}
        className='toast_success'
      />
      {message}
    </div>
  );
}

export function warning(message) {
  toast.warning(
    <div>
      <AlertTriangle
        style={{ marginRight: '0.3rem' }}
        className='toast_warning'
      />
      {message}
    </div>
  );
}

export function error(message) {
  toast.error(
    <div>
      <XCircle style={{ marginRight: '0.3rem' }} className='toast_error' />
      {message}
    </div>
  );
}

export function info(message) {
  toast.info(
    <div>
      <Info style={{ marginRight: '0.3rem' }} className='toast_info' />
      {message}
    </div>
  );
}

export function defaults(message) {
  toast(
    <div>
      <Info style={{ marginRight: '0.3rem' }} className='toast_default' />
      {message}
    </div>
  );
}
